
export const environment = {
    production: false,
    environment: 'development',
    baseURL:'https://dev.back.nauffar.com',
    baseUserURL:'https://dev.back.nauffar.com/back',
    encryptionKey: 'DEV_AES_ENCRYPTION_KEY_58e7f2a3b9c1d6',
    signingKey: 'DEV_HMAC_SIGNING_KEY_71c3d4e5f2a8b9',
    firebase:{
        apiKey: "AIzaSyCOw8gjpbob2JlPrKy-qMbmg-Zv9wSYF_w",
        authDomain: "nauffar-dev.firebaseapp.com",
        projectId: "nauffar-dev",
        storageBucket: "nauffar-dev.firebasestorage.app",
        messagingSenderId: "630991255454",
        appId: "1:630991255454:web:4f45e66b8f91cb49b6088f"
    }
};
